module.exports = __webpack_public_path__ + "img/badge_buoni_wishlist.8147de64.jpg";